import { z } from "zod";

import { FeaturesCodes } from "../enum/codes";

export const FeatureSchema = z.object({
	feature: z.nativeEnum(FeaturesCodes),
	active: z.boolean(),
});

export const FeaturesResponseSchema = FeatureSchema.array();

export type Feature = z.infer<typeof FeatureSchema>;
export type FeaturesResponse = z.infer<typeof FeaturesResponseSchema>;
